import type { ReactNode } from "react";

import RowActionMenu from "@RequestFormV2/sections/PackingList/components/shared/RowActionMenu";

type PackingListTableRowProps = {
  rowNumber: number;
  children: ReactNode;
  showActions?: boolean;
  onDuplicate?: () => void;
  onDelete?: () => void;
  deleteDisabled?: boolean;
};

export default function PackingListTableRow({
  rowNumber,
  children,
  showActions = true,
  onDuplicate,
  onDelete,
  deleteDisabled = false,
}: PackingListTableRowProps) {
  return (
    <div className="rfv2-packing-list-table__row">
      <div className="rfv2-packing-list-table__edge rfv2-packing-list-table__edge--left" aria-hidden="true" />
      <div className="rfv2-packing-list-table__row-number">
        <span className="rfv2-packing-list-table__row-index">{rowNumber}</span>
      </div>
      <div className="rfv2-packing-list-table__row-scroll">{children}</div>
      {showActions && onDuplicate && onDelete && (
        <div className="rfv2-packing-list-table__row-actions">
          <RowActionMenu onDuplicate={onDuplicate} onDelete={onDelete} deleteDisabled={deleteDisabled} />
        </div>
      )}
      <div className="rfv2-packing-list-table__edge rfv2-packing-list-table__edge--right" aria-hidden="true" />
    </div>
  );
}
